import React from 'react';
import trackmanColorCalc from '../../utils/color/trackmanColorCalc';
import { useTranslation } from 'react-i18next';

function IndicatorChart({data, realData, title, type}) {
    let numberCalc = (type === 'batter') ? (100-Math.round(data*100)) : (Math.round(data*100));

    if(title === 'strikeOut%' || title === 'chase%' || title === 'whiff%'
    || title === 'K%' || title === 'K/9') { //batter
        numberCalc = 100-numberCalc;
    } else if( title === 'fastballVelocity' || title === 'strike%' 
    || title === 'gbPopup%' || title === 'fastballSpin') {
        numberCalc = 100-numberCalc;
    }

    const { t } = useTranslation();

    const startPoint = 0;
    const endPoint = 73;

    let pointLength = endPoint-startPoint;    
    let dataPoint = data ? (numberCalc/100)*pointLength : null;
    let colorObj = data ? trackmanColorCalc(numberCalc) : null;

    return (
        <>
        { data ?
        <svg width="110" height="45">
            <text x="5" y="13" fontSize={11}>{t(title)}</text>
            <g transform="translate(15,0)">
                <line x1="0" x2="73" y1="25" y2="25" stroke="#9b9b9b" strokeWidth="3px"></line>
                <circle cx="0.365" cy="25" r="2" fill="#9b9b9b" stroke="#9b9b9b"></circle>
                <circle cx="73.365" cy="25" r="2" fill="#9b9b9b" stroke="#9b9b9b"></circle>
                <circle cx="36.5" cy="25" r="2" fill="#9b9b9b" stroke="#9b9b9b"></circle>
                <g id="slider_percent_rank_exit_velocity_avg" transform={`translate(${dataPoint},25)`}>
                    <circle r="10" fill={colorObj['bgColor']} stroke="#000"></circle>
                    <text dy="4" textAnchor="middle" 
                    fill={colorObj['textColor']} fontSize=".7rem">{numberCalc}</text>
                    <text dy="18" textAnchor="middle" 
                    fill={'black'} fontSize=".7rem">{realData}</text>
                </g>
            </g>
        </svg> :
        <svg width="110" height="40"></svg>
        }
        
        </>
    )
}

export default IndicatorChart;